import { CargoTypeMode, CargoTypeModes, StopStatus, StopType, UnitsWeight } from "harmony-constants";
import { stopHasCargo } from "../constants/constants";
import { Stop } from "../types";
import { convert } from '../components/shared/hooks/use-weights';
import { L } from 'harmony-language';
import { BushelConversions } from 'harmony-constants/lib/src/db/constants';

//Given a stop list, get the tractor/trailer information and show the current weight of
//the vehicle plus cargo, taking into account delivered stops.  If there is no tractor
//or trailer weight, this function returns "undefined".
export const getCurrentLoadWeight = (tractorWeight: number | null | undefined, trailerWeight: number | null | undefined, stops: Stop[]) => {
    if (!tractorWeight || !trailerWeight) {
        return undefined;
    }

    const equipmentWeight = tractorWeight + trailerWeight;

    const completedCargoStops = stops.filter(x => stopHasCargo(x) && x.status === StopStatus.Complete)
    const completedStopWeightAdjustments = completedCargoStops.map(x => {
        //Origins add weight, Destinations remove, anything else should have no effect on weight
        const stopTypeCoefficientMap: Partial<Record<StopType, number>> = { [StopType.Origin]: 1, [StopType.Destination]: -1 }
        const coefficient = stopTypeCoefficientMap[x.type] || 0;
        return coefficient * (x.actualWeight || x.weight || 0);
    });
    const cargoWeight = completedStopWeightAdjustments.reduce((acc, cur) => acc + cur, 0);

    return equipmentWeight + cargoWeight;
}

export const getIsBushelCargo = (stop: Stop): boolean => {
    const bushelCargoTypeIds = Object.keys(CargoTypeModes)
        // @ts-ignore
        .filter(keyId => CargoTypeModes[keyId] === CargoTypeMode.Bushels)
        .map(idStr => Number(idStr));
    return bushelCargoTypeIds.includes(stop.cargoTypeId || -1);
}

export const convertGramsToBushels = (amount: number, cargoTypeId: number): number => {
    return  convert('gram', UnitsWeight.Pound, 0)(amount / (BushelConversions[cargoTypeId]));
}

export const convertGramsToBushelsDisplay = (amount: number, cargoTypeId: number): string => {
    const bushels = convertGramsToBushels(amount, cargoTypeId);
    return `${bushels} ${L.unitsBushelAbbr()}`;
}

export const convertBushelsToGrams = (amount: number, cargoTypeId: number): number => {
    return convert(UnitsWeight.Pound, 'gram', 0)(amount * (BushelConversions[cargoTypeId]));
}